import { render, staticRenderFns } from "./ProgressTabAdministrator.vue?vue&type=template&id=5f6c117b&scoped=true&"
import script from "./ProgressTabAdministrator.vue?vue&type=script&lang=ts&"
export * from "./ProgressTabAdministrator.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressTabAdministrator.vue?vue&type=style&index=0&id=5f6c117b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6c117b",
  null
  
)

export default component.exports